import React, { ReactNode } from "react";
import { useTranslation } from 'react-i18next';
import {
    BsCardChecklist,
    BsFileEarmarkFill,
    BsFillDoorOpenFill,
    BsGrid,
    BsListStars,
    BsMegaphone,
    BsPlusSquare,
    BsShop,
    BsSpeedometer2,
    BsVectorPen
} from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../../providers";
import "../assets/css/Sidebar.css";

export interface IMenuItem {
    key: number;
    label: string;
    destiny: string;
    icon: ReactNode;
}

export interface IMenu {
    label: string;
    icon: React.JSX.Element;
    items: IMenuItem[] | never[];
    url: string | null;
    action?: () => Promise<void>
}

export interface IMenus {
    unsubscriberMenu: IMenu[];
    subscriberMenu: IMenu[];
    managerMenu: IMenu[];
}

// Função para criar os menus
export const CreateMenus = (includeAdsItems: string, isSmall: boolean = false): IMenus => {
    const { t } = useTranslation('admPanel');
    const navigate = useNavigate();
    const { handleLogout, userData } = useAuth();

    const logoutCommand = async () => {
        navigate("/");
        await handleLogout();
    }

    const logoutMenu: IMenu =
    {
        label: t('logout'),
        icon: (
            <BsFillDoorOpenFill />
        ),
        items: [],
        url: '/',
        action: logoutCommand
    };

    const subscriptionsMenuItems: IMenuItem[] = [
        {
            key: 1,
            label: t('subscriber_area_subscriptions_extract'),
            destiny: "/adm/subscription/statement",
            icon: (
                <BsCardChecklist className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        },
    ];

    const paymentOrdersManagerMenuItems: IMenuItem[] = [
        {
            key: 1,
            label: t('manager_area_subscriptions_menu_item_list'),
            destiny: "/adm/paymentOrder",
            icon: (
                <BsCardChecklist className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        },
    ];

    const reportsManagerMenuItems: IMenuItem[] = [
        {
            key: 1,
            label: t('manager_area_reports_menu_item_list_subscriptions'),
            destiny: "/adm/report/subscriptions",
            icon: (
                <BsCardChecklist className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        },
    ];

    const productsItems: IMenuItem[] = [
        {
            key: 1,
            label: t('subscriber_area_products_create'),
            destiny: "/adm/productCreate",
            icon: (
                <BsPlusSquare className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        },
        {
            key: 2,
            label: t('subscriber_area_products_list'),
            destiny: "/adm/productList",
            icon: (
                <BsListStars className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        },
    ];

    const adsMenuItems: IMenuItem[] = includeAdsItems === 'shown' ? [
        {
            key: 1,
            label: t('subscriber_area_ads_create'),
            destiny: "/adm/ads-create",
            icon: (
                <BsPlusSquare className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        },
        {
            key: 2,
            label: t('subscriber_area_ads_list'),
            destiny: "/adm/ads-list",
            icon: (
                <BsPlusSquare className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        },
    ] : includeAdsItems === 'hidden' ? [
        {
            key: 1,
            label: t('subscriber_area_ads_subscribe'),
            destiny: "/ads/subscribe",
            icon: (
                <BsPlusSquare className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        }
    ] : [
        {
            key: 1,
            label: t('subscriber_area_ads_subscribe'),
            destiny: "/adm/ads-statement",
            icon: (
                <BsPlusSquare className="d-xs-inline d-md-none ds-sidebar-item-icon" />
            ),
        }
    ];

    const unsubscriberMenu: IMenu[] = [
        {
            label: t('subscriber_area_dashboard_label'),
            icon: <BsSpeedometer2 />,
            items: [],
            url: '/adm/dashboard',
        },
        {
            label: t('subscriber_area_subscriptions_label'),
            icon: <BsVectorPen />,
            items: subscriptionsMenuItems,
            url: null,
        },
    ];

    const subscriberMenu: IMenu[] = [
        {
            label: t('subscriber_area_dashboard_label'),
            icon: <BsSpeedometer2 />,
            items: [],
            url: '/adm/dashboard',
        },
        {
            label: t('subscriber_area_subscriptions_label'),
            icon: <BsVectorPen />,
            items: subscriptionsMenuItems,
            url: null,
        },
        {
            label: t('subscriber_area_products_label'),
            icon: <BsGrid />,
            items: productsItems,
            url: null,
        },
        {
            label: t('subscriber_area_ads_label'),
            icon: <BsMegaphone />,
            items: adsMenuItems,
            url: null,
        },
        {
            label: t('back_to_site'),
            icon: <BsShop />,
            items: [],
            url: "/home",
        }
    ];

    const managerMenu: IMenu[] = [
        {
            label: t('manager_area_dashboard_label'),
            icon: <BsSpeedometer2 />,
            items: [],
            url: '/adm/dashboard',
        },
        {
            label: t('manager_area_subscriptions_label'),
            icon: <BsVectorPen />,
            items: paymentOrdersManagerMenuItems,
            url: null,
        },
        {
            label: t('manager_area_reports_label'),
            icon: <BsFileEarmarkFill />,
            items: reportsManagerMenuItems,
            url: null,
        },
        logoutMenu
    ];
    if (isSmall) {
        subscriberMenu.push(logoutMenu);
    }

    return {
        unsubscriberMenu,
        subscriberMenu,
        managerMenu,
    };
};